import React from 'react';
import CustomModal from '../reusable/CustomModal';
import './DataApprovalWorkflowModal.css';

interface DataApprovalWorkflowModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const DataApprovalWorkflowModal = ({ isOpen, onClose }: DataApprovalWorkflowModalProps) => {
  return (
    <CustomModal isOpen={isOpen} handleClose={onClose} title="Data approval workflow" icon={false} maxWidth="md">
      <p className="data-approval-modal-description">
        This workflow shows how district data moves from upload to final approval. Each step must be completed in order,
        with both XQ and district reviews required before school reports can be generated.
      </p>
      <div className="data-approval-workflow-steps">
        <div className="workflow-step completed">
          <div className="step-indicator completed">
            <span className="step-number">1</span>
          </div>
          <div className="step-content">
            <h3 className="step-title">Data Upload</h3>
            <p className="step-description">The district uploads all data required for the EOAA.</p>
          </div>
        </div>

        <div className="workflow-step completed">
          <div className="step-indicator completed">
            <span className="step-number">2</span>
          </div>
          <div className="step-content">
            <h3 className="step-title">Internal review</h3>
            <p className="step-description">After all data is uploaded, XQ conducts an internal data quality check.</p>
          </div>
        </div>

        <div className="workflow-step current">
          <div className="step-indicator current">
            <span className="step-number">3</span>
          </div>
          <div className="step-content">
            <h3 className="step-title">District review</h3>
            <p className="step-description">
              After XQ's review, a district representative must approve the data on this dashboard.
            </p>
          </div>
        </div>

        <div className="workflow-step unavailable">
          <div className="step-indicator unavailable">
            <span className="step-number">4</span>
          </div>
          <div className="step-content">
            <h3 className="step-title">Data finalized</h3>
            <p className="step-description">
              When both XQ and the district approve the data, the school reports can be generated.
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default DataApprovalWorkflowModal;
